import { resolveFranchiseSlugFromPath } from "./franchiseSlug";

export type FranchiseTenantState = {
  slug?: string | null;
  branding?: { isRoot?: boolean } | null;
};

const ROOT_SLUGS = new Set(["lavoris", "root"]);

function isFranchiseSlug(slug?: string | null): boolean {
  const normalized = slug?.trim().toLowerCase();
  return Boolean(normalized && !ROOT_SLUGS.has(normalized));
}

/**
 * true solo en `/socios/{slug}` (franquicia real).
 * Por defecto false → root Lavoris conserva todo el módulo de ausentismo.
 */
export function isFranchiseTenant(
  franchiseState: FranchiseTenantState,
): boolean {
  if (franchiseState.branding?.isRoot === true) return false;

  if (isFranchiseSlug(resolveFranchiseSlugFromPath())) return true;
  if (isFranchiseSlug(franchiseState.slug)) return true;
  if (franchiseState.branding?.isRoot === false) return true;

  return false;
}

export function isAbsenteeismMenuItem(item: {
  title?: string;
  linkTo?: string;
}): boolean {
  const title = (item.title ?? "").trim().toLowerCase();
  const linkTo = (item.linkTo ?? "").trim().toLowerCase();
  if (title.includes("ausentismo")) return true;
  if (
    linkTo === "/ausentismo" ||
    linkTo.endsWith("/ausentismo") ||
    linkTo === "ausentismo"
  ) {
    return true;
  }
  return false;
}

export function filterAbsenteeismMenuItems<
  T extends { title?: string; linkTo?: string },
>(items: T[], hideAbsenteeism: boolean): T[] {
  if (!hideAbsenteeism) return items;
  return items.filter((item) => !isAbsenteeismMenuItem(item));
}

export function isAbsenteeismPath(pathname: string): boolean {
  return pathname.toLowerCase().includes("/ausentismo");
}

export function isAbsenteeismReportTab(tab: string): boolean {
  return tab.trim().toLowerCase().includes("ausentismo");
}

export function filterAbsenteeismReportTabs(
  tabs: string[],
  hideAbsenteeism: boolean,
): string[] {
  if (!hideAbsenteeism) return tabs;
  return tabs.filter((tab) => !isAbsenteeismReportTab(tab));
}

export function filterAbsenteeismRoleTabs<
  T extends { id?: string; label?: string },
>(tabs: T[], hideAbsenteeism: boolean): T[] {
  if (!hideAbsenteeism) return tabs;
  return tabs.filter((tab) => {
    const text = `${tab.id ?? ""} ${tab.label ?? ""}`.toLowerCase();
    return !text.includes("ausentismo");
  });
}

export function isCuentaCorrienteMenuItem(item: {
  title?: string;
  linkTo?: string;
}): boolean {
  const title = (item.title ?? "").trim().toLowerCase();
  const linkTo = (item.linkTo ?? "").trim().toLowerCase();
  if (title.includes("cuenta corriente")) return true;
  if (
    linkTo === "/cuenta-corriente" ||
    linkTo.endsWith("/cuenta-corriente") ||
    linkTo === "cuenta-corriente"
  ) {
    return true;
  }
  return false;
}

export function filterCuentaCorrienteMenuItems<
  T extends { title?: string; linkTo?: string },
>(items: T[], hideCuentaCorriente: boolean): T[] {
  if (!hideCuentaCorriente) return items;
  return items.filter((item) => !isCuentaCorrienteMenuItem(item));
}

export function isCuentaCorrientePath(pathname: string): boolean {
  return pathname.toLowerCase().includes("/cuenta-corriente");
}

/** Franquicia: clientCode o "---". Root: managerId (sin cambiar visual). */
export function getDisplayClientCode(
  company:
    | {
        managerId?: string | null;
        clientCode?: string | null;
      }
    | null
    | undefined,
  isFranchise: boolean,
): string {
  if (isFranchise) {
    return company?.clientCode?.trim() || "---";
  }
  return company?.managerId?.trim() || "---";
}
